import { AccordionSubItem } from '../components/navigation/Accordion/types';
import {
  optionsTypes,
  recursiveTypes,
} from '../components/navigation/HamburguerMenu/types';
import { Role } from '../types/auth';
import { options } from './definitionGloblaRoutes';

const hasPermission = (route: recursiveTypes, userRole: Role) => {
  return route.permissions && route.permissions?.includes(userRole);
};

export const filterAllowedRoutes = (
  routes: recursiveTypes[],
  userRole: Role
): recursiveTypes[] => {
  const allowedRoutes: recursiveTypes[] = [];
  for (const route of routes) {
    if (hasPermission(route, userRole)) {
      if (route.label && route.value) {
        allowedRoutes.push({
          label: route.label,
          value: route.value,
          data: route.data
            ? (filterAllowedRoutes(
                route.data as recursiveTypes[],
                userRole
              ) as optionsTypes[])
            : [],
        });
      } else if (route.title && (route.path || route.path === '')) {
        allowedRoutes.push({
          title: route.title,
          path: route.path,
          subItems: route.subItems
            ? (filterAllowedRoutes(
                route.subItems as recursiveTypes[],
                userRole
              ) as AccordionSubItem[])
            : [],
        });
      } else if (route.text && (route.path || route.path === '')) {
        allowedRoutes.push({
          text: route.text,
          path: route.path,
        });
      }
    }
  }
  return allowedRoutes;
};

/**
 * Get the default route for a user based on their role
 * Uses explicit role-to-route mappings to ensure correct redirect behavior
 * independent of the menu order in the options array
 *
 * @param userRole - The role of the user
 * @returns The path to redirect to (e.g., "/work-orders" for Coex/SuperAdmin)
 */
export const getDefaultRouteForRole = (userRole: Role): string => {
  // Mapeo explícito de ruta por defecto por rol
  const roleDefaultRoutes: Partial<Record<Role, string>> = {
    [Role.Coex]: '/work-orders',
    [Role.Capataz]: '/work-orders', // clon de Coex: misma landing tras login
    [Role.SuperAdmin]: '/work-orders',
  };

  // Si hay mapeo explícito, usarlo
  if (roleDefaultRoutes[userRole]) {
    return roleDefaultRoutes[userRole]!;
  }

  // Para otros roles, usar la primera ruta permitida
  const allowedRoutes = filterAllowedRoutes(options, userRole);
  if (allowedRoutes.length > 0 && allowedRoutes[0].value) {
    return `/${allowedRoutes[0].value}`;
  }

  // Fallback to login if no routes are accessible
  return '/login';
};
